import Vue from "vue";
export var TermConditionEventBus = new Vue();